// extracted by mini-css-extract-plugin
module.exports = {"contentLoaderContainer":"loader_contentLoaderContainer__2WSSA","contentLoader":"loader_contentLoader__R3FUW","spinner":"loader_spinner__3d4s-"};